// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:20:35

export default {
  "id": "bubble-up",
  "slug": "bubble-up",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/528f190140254420a971b79f822cffab-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/528f190140254420a971b79f822cffab/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bubble Up",
      "description": "Help BUB, a tiny bubble, fulfill its dream of reaching the blazing sun. Use his bubble friends, BLE, to push BUB past obstacles, rise from the ground to towering buildings, and conquer the skies!\n\nYou only need to shoot out BLE by click left mouse, good luck!",
      "instructions": "Left-click to shoot a new bubble. Use physics interactions to adjust the trajectory, ensuring at least one bubble can avoid obstacles and rise higher.\n\nNote: Bubbles attached to the original bubble will be given 'emotions.' The level is only completed when at least one bubble with 'emotions' successfully ascend.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "challenge",
        "cute",
        "physics"
      ]
    },
    "zh-CN": {
      "title": "泡泡上升",
      "description": "帮助BUB，一个微小的泡泡，实现它到达炽热太阳的梦想。利用泡泡朋友BLE推动BUB越过障碍，从地面上升到摩天大楼，征服天空！\n\n你只需通过点击鼠标左键射出BLE，祝你好运！",
      "instructions": "左键点击发射新泡泡。利用物理交互调整轨迹，确保至少有一个泡泡能够避开障碍物并上升更高。\n\n注意：连接到原始泡泡的泡泡将获得“情感”。只有当至少有一个带有“情感”的泡泡成功上升时，关卡才算完成。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1玩家",
        "2D",
        "挑战",
        "可爱",
        "物理"
      ]
    },
    "zh-TW": {
      "title": "泡泡上升",
      "description": "幫助BUB，一個小小的泡泡，實現他夢想達到灼熱的太陽。使用他的泡泡朋友BLE推BUB通過障礙，從地面升起至高樓大廈，征服天空！\n\n你只需要左鍵點擊射出BLE，祝你好運！",
      "instructions": "左鍵點擊發射新泡泡。使用物理互動調整軌道，確保至少一個泡泡能避開障礙並上升更高。\n\n注意：附著於原始泡泡的泡泡將被賦予「情感」。只有當至少一個帶有「情感」的泡泡成功上升時，關卡才會完成。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人遊玩",
        "2D",
        "挑戰",
        "可愛",
        "物理學"
      ]
    },
    "zh-HK": {
      "title": "泡泡上升",
      "description": "幫助BUB，一個小泡泡，實現夢想，抵達烈日當空。利用他的泡泡好友BLE推著BUB通過障礙，從地面上升到摩天大樓，征服天空！\n\n你只需點擊左鍵射出BLE，祝你好運！",
      "instructions": "左鍵點擊發射新泡泡。利用物理互動調整彈道，確保至少一個泡泡能夠避開障礙並上升得更高。\n\n注意：連接到原泡泡的泡泡將會被賦予「情感」。只有當至少一個帶有「情感」的泡泡成功上升時，才會完成關卡。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "2D",
        "挑戰",
        "可愛",
        "物理學"
      ]
    },
    "ja": {
      "title": "バブルアップ",
      "description": "BUB、小さなバブルの夢を叶えるために、その友達BLEを使って障害物を乗り越え、地面から高いビルに昇り、空を征服しましょう。左クリックでBLEを撃ち出せばいいだけです、運気を祈っています！",
      "instructions": "左クリックで新しい泡を射出します。物理的な相互作用を使用して軌道を調整し、少なくとも1つの泡が障害物を避け、より高い場所に上昇できるようにします。\n\n注意：元の泡に付いた泡には「感情」が与えられます。レベルは、「感情」を持つ少なくとも1つの泡が成功して上昇したときにのみ完了します。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "挑戦",
        "可愛い",
        "物理"
      ]
    },
    "ko": {
      "title": "버블업",
      "description": "BUB라는 작은 볼이 태양에 도달하는 꿈을 이루기 위해 도와주세요. BLE라는 볼 친구들을 사용하여 BUB을 장애물을 넘어,地面에서 높은 빌딩으로 올라가고 하늘을 정복하세요!\n\n왼쪽 마우스 클릭으로 BLE를 발사하세요, 행운을 빕니다!",
      "instructions": "왼쪽 클릭으로 새 거품을 발사하세요. 물리적 상호작용을 사용하여 트랙션을 조정하고, 최소한 하나의 거품이 장애물을 피하여 더 높이 올라가도록 하세요.\n\n주의事项: 원래 거품에 연결된 거품에는 '감정'이 주어집니다. 최소한 하나의 '감정'을 가진 거품이 성공적으로 상승할 때까지 레벨이 완료되지 않습니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "도전",
        "귀여운",
        "물리학"
      ]
    },
    "fr": {
      "title": "Remontée de bulles",
      "description": "Aidez BUB, une petite bulle, à réaliser son rêve de atteindre le soleil brûlant. Utilisez ses amis en bulles, BLE, pour pousser BUB au-delà des obstacles, grimper de la terre aux gratte-ciel, et conquérir les cieux !\n\nIl suffit de tirer BLE en cliquant avec le bouton gauche de la souris, bonne chance !",
      "instructions": "Cliquez avec le bouton gauche pour tirer une nouvelle bulle. Utilisez les interactions physiques pour ajuster la trajectoire, en vous assurant qu'au moins une bulle puisse éviter les obstacles et monter plus haut.\n\nNote : Les bulles attachées à la bulle originale recevront des \"émotions\". Le niveau n'est terminé que lorsque au moins une bulle avec des \"émotions\" monte avec succès.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "défi",
        "mignon",
        "physique"
      ]
    }
  }
};
